import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { Loader } from "../Components/Loader";
import { Api } from "../Utils/Api";
import { ErrorModal } from "../Components/Erro";
import { DiagnosticRelatedInformation } from "typescript";
import { api_enderecos, api_login_unico_url } from "../Utils/Urls";
import axios from "axios";
const EntidadeContext = createContext({} as ContextData);

interface ContextData {
  entidades: Entidade[];
  entidadeFocus: Entidade;
  setEntidadeFocus:React.Dispatch<React.SetStateAction<Entidade>>;
}

function useEntidade() {
  const context = useContext(EntidadeContext);
  if (!context) {
    throw new Error("useEntidade deve ser usado dentro de um EntidadeProvider");
  }
  return context;
}

interface IProviderProps {
  children: ReactNode;
}
export interface Entidade {
  id: number;
  titulo: string;
  banco: string;
  logo: string;
  apresentacao: string;
  portal: string;
  site: string;
  site2: string;
  pasta: string;
}

function EntidadeProvider({ children }: IProviderProps) {
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState({ titulo: "", descricao: "" });
  const [entidades, setEntidades] = useState([] as Entidade[]);
  const [entidadeFocus, setEntidadeFocus] = useState({} as Entidade);

  async function getEntidades() {
    try {
      setLoading(true);
      const { data } = await axios.get(`${api_enderecos}`);
      data.forEach((item: Entidade) => {
        item.logo = `${api_enderecos}/uploads/${item.logo}`;
      });
      setEntidades(data);
    } catch (e) {
      window.alert(JSON.stringify(e));
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getEntidades();
  }, []);

  return (
    <EntidadeContext.Provider value={{ entidades,entidadeFocus, setEntidadeFocus}}>
      <Loader loading={loading} />
      <ErrorModal
        description={erro.descricao}
        title={erro.titulo}
        onClose={() => setErro({ descricao: "", titulo: "" })}
        open={erro.titulo.length > 0 && erro.descricao.length > 0}
      />
      {children}
    </EntidadeContext.Provider>
  );
}

export { EntidadeProvider, useEntidade };
